import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import hasProperty from "lodash/has";

/**
 * options for formErrorClass:
 * form-error (default)
 * form-error-inverse
 *  */
function Textarea({
  id,
  name,
  onChange,
  onReturnKey = () => {},
  onClick = () => {},
  onBlur = () => {},
  errors,
  errorKey,
  classes = "",
  placeholder = "",
  fieldValue = "",
  formErrorClass = "form-error"
}) {
  const [formError, setFormError] = useState("");
  const [formErrorMessage, setFormErrorMessage] = useState("");

  useEffect(() => {
    setFormError("");
    setFormErrorMessage("");

    if (
      hasProperty(errors, "response.data.data.errors") &&
      errors.response.data.data.errors.length > 0
    ) {
      for (const iterator of errors.response.data.data.errors) {
        if (iterator.field === errorKey) {
          setFormError(formErrorClass || "form-error");
          setFormErrorMessage(iterator.message);
        }
      }
    }
  }, [name, errorKey, errors, formErrorClass]);

  const onInputChange = () => {
    setFormError("");
    setFormErrorMessage("");
  };

  return (
    <>
      <textarea
        id={id}
        name={name}
        placeholder={placeholder}
        value={fieldValue}
        className={`form-input ${classes} ${formError}`}
        onChange={e => {
          onInputChange(e);
          onChange(e);
        }}
        onBlur={e => onBlur(e)}
        onClick={e => onClick(e)}
        onKeyUp={e => (e.which === 13 && onReturnKey ? onReturnKey() : null)}
      ></textarea>
      {formErrorMessage && <div className={formError}>{formErrorMessage}</div>}
    </>
  );
}

Textarea.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onReturnKey: PropTypes.func,
  onClick: PropTypes.func,
  onBlur: PropTypes.func,
  errors: PropTypes.object,
  errorKey: PropTypes.string.isRequired, // The string that the api error returns in the "field" key
  classes: PropTypes.string,
  placeholder: PropTypes.string,
  fieldValue: PropTypes.string,
  formErrorClass: PropTypes.string
};

export default Textarea;
